import { render, staticRenderFns } from "./behavior.vue?vue&type=template&id=2d2754c4&"
import script from "./behavior.vue?vue&type=script&lang=js&"
export * from "./behavior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports